import { useContentManager } from '../../hooks/useContentManager';

function TextBlock({ section }: { section: string }) {
  const { getContentItem } = useContentManager();
  const item = getContentItem('home', section);
  const titleLine1 = item?.metadata?.title_line1 || 'WHY';
  const titleBold = item?.metadata?.title_bold || 'Golden Tower?';
  const description = item?.metadata?.description || '';
  const buttonText = item?.metadata?.button_text || '';
  const buttonUrl = item?.metadata?.button_url || '';

  return (
    <section className="py-20 bg-black text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-light mb-6">
          {titleLine1} <span className="font-bold">{titleBold}</span>
        </h2>
        {description && (
          <p className="text-gray-300 max-w-4xl mx-auto mb-10 leading-relaxed">{description}</p>
        )}
        {buttonText && (
          <a
            href={buttonUrl || '#'}
            className="inline-block border border-white px-8 py-3 text-sm tracking-wider hover:bg-white hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {buttonText}
          </a>
        )}
      </div>
    </section>
  );
}

export default function HomeTextBlocks() {
  return (
    <div>
      <TextBlock section="text-block-1" />
    </div>
  );
}
